import React,{useState} from 'react';
import {motion} from 'framer-motion';
import {Link} from 'react-router-dom';
import {siteData} from '../../data/content';
import VehicleNote from '../ui/VehicleNote';
import * as FiIcons from 'react-icons/fi';
const {FiCheck,FiArrowRight,FiPhone}=FiIcons;

const BOOKING_URL="https://app.urable.com/virtual-shop/cFNwotdAvEx76Evup5X1";

const vehicleTypes=[ 
  {key: 'sedan',label: 'Sedan'},
  {key: 'truck',label: 'Truck / SUV'},
  {key: 'xl',label: 'Van / XL SUV'},
];

export default function PackagesPreview() {
  const [activeVehicle,setActiveVehicle]=useState('sedan');

  return ( 
    <section className="py-24 bg-slate-950 border-b border-slate-800"> 
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
        <div className="text-center mb-6"> 
          <span className="text-blue-500 font-bold tracking-widest uppercase text-xs mb-3 block">Transparent Pricing</span> 
          <h2 className="text-3xl md:text-5xl font-black text-white uppercase tracking-tight mb-4"> Detailing Packages </h2> 
          <p className="text-slate-400 max-w-xl mx-auto text-base"> Three clear packages built for every need. Select your vehicle type to see pricing. </p> 
        </div> 
        <div className="flex justify-center mb-12"> 
          <div className="inline-flex bg-slate-900 border border-slate-800 rounded-sm p-1 gap-1"> 
            {vehicleTypes.map((v)=> ( 
              <button key={v.key} onClick={()=> setActiveVehicle(v.key)} className={`px-5 py-2.5 text-xs font-bold uppercase tracking-widest rounded-sm transition-all ${activeVehicle===v.key ? 'bg-blue-600 text-white shadow-[0_0_12px_rgba(37,99,235,0.4)]' : 'text-slate-400 hover:text-white'}`} > 
                {v.label} 
              </button> 
            ))} 
          </div> 
        </div> 
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mb-6"> 
          {siteData.packages.map((pkg,index)=> ( 
            <motion.div key={pkg.id} initial={{opacity: 0,y: 20}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{delay: index * 0.1}} className={`relative flex flex-col rounded-sm border ${pkg.featured ? 'border-blue-500 bg-slate-900 shadow-[0_0_40px_rgba(37,99,235,0.15)] md:-mt-4 md:mb-4' : 'border-slate-800 bg-slate-900/60'}`} > 
              {pkg.featured && ( 
                <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-blue-600 text-white px-5 py-1 text-xs font-black uppercase tracking-widest rounded-sm whitespace-nowrap"> 
                  ⭐ Most Popular 
                </div> 
              )} 
              <div className={`p-7 flex flex-col flex-grow ${pkg.featured ? 'pt-9' : ''}`}> 
                <div className="mb-6 pb-6 border-b border-slate-800"> 
                  <span className="text-blue-500 text-xs font-bold uppercase tracking-widest block mb-2">{pkg.tier}</span> 
                  <h3 className="text-2xl font-black text-white uppercase tracking-tight mb-1">{pkg.name}</h3> 
                  <p className="text-slate-400 text-sm mb-4 italic">{pkg.tagline}</p> 
                  <motion.div key={activeVehicle} initial={{opacity: 0,y: -6}} animate={{opacity: 1,y: 0}} className="text-4xl font-black text-white" > 
                    {pkg.pricing[activeVehicle]} 
                  </motion.div> 
                  <p className="text-slate-500 text-xs mt-1"> 
                    {activeVehicle==='sedan' ? 'Sedan' : activeVehicle==='truck' ? 'Truck / SUV' : 'Van / XL SUV'} 
                  </p> 
                </div> 
                <ul className="space-y-3 mb-8 flex-grow"> 
                  {pkg.features.map((feature,i)=> ( 
                    <li key={i} className="flex items-start gap-3 text-slate-300 text-sm"> 
                      <FiCheck className="text-blue-500 mt-0.5 flex-shrink-0 text-base" /> 
                      <span>{feature}</span> 
                    </li> 
                  ))} 
                </ul> 
                <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className={`w-full inline-flex items-center justify-center gap-2 py-3.5 rounded-sm font-bold uppercase tracking-wide text-sm transition-all ${pkg.featured ? 'bg-blue-600 text-white hover:bg-blue-500 shadow-[0_0_20px_rgba(37,99,235,0.3)]' : 'border-2 border-slate-700 text-white hover:border-blue-500 hover:text-blue-400'}`} > 
                  Book Now <FiArrowRight className="text-xs" /> 
                </a> 
              </div> 
            </motion.div> 
          ))} 
        </div> 
        {/* Vehicle sizing note */} 
        <div className="mb-6"> 
          <VehicleNote variant="default" /> 
        </div> 
        <div className="text-center mb-8"> 
          <p className="text-slate-500 text-sm italic"> 
            * Pricing may vary based on vehicle condition. Deposit may be required for new customers. 
          </p> 
        </div> 
        <div className="bg-slate-900 border border-slate-800 rounded-sm p-6 flex flex-col sm:flex-row items-center justify-between gap-4"> 
          <div> 
            <p className="text-white font-bold text-sm uppercase tracking-wide">Not sure which package is right for you?</p> 
            <p className="text-slate-400 text-xs mt-1">Call us and we'll recommend the best fit for your vehicle.</p> 
          </div> 
          <div className="flex gap-3"> 
            <a href={`tel:${siteData.business.phoneTel}`} className="inline-flex items-center gap-2 px-5 py-3 bg-blue-600 text-white font-bold rounded-sm hover:bg-blue-500 transition-all uppercase tracking-wide text-xs" > 
              <FiPhone className="text-sm" /> {siteData.business.phone} 
            </a> 
            <Link to="/packages" className="inline-flex items-center gap-2 px-5 py-3 border border-slate-700 text-slate-300 font-bold rounded-sm hover:border-blue-500 hover:text-blue-400 transition-all uppercase tracking-wide text-xs" > 
              All Packages 
            </Link> 
          </div> 
        </div> 
      </div> 
    </section> 
  );
}